import React from "react";
import { Popper } from "@mui/base/Popper";
import { ClickAwayListener } from "@mui/base/ClickAwayListener";
import { Autocomplete, AutocompleteOption } from "@mui/joy";
import { Box, Sheet, Typography } from "@mui/joy";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import colors from "@mui/joy/colors";
import ListboxComponent from "../ListboxComponent";
import { Avatar } from "InnoUI/components";
import theme from "theme";

const DropdownList = (props) => {
  const {
    id,
    open,
    anchorEl,
    handleClose,
    pendingValue,
    setPendingValue,
    labels,
    value,
  } = props;

  return (
    <Popper
      id={id}
      open={open}
      anchorEl={anchorEl}
      placement="bottom-start"
      style={{ zIndex: 2000 }}
    >
      <ClickAwayListener onClickAway={handleClose}>
        <Sheet
          variant="outlined"
          sx={(theme) => ({
            width: 300,
            boxShadow: "md",
            borderRadius: "6px",
            overflow: "hidden",
            "--joy-palette-neutral-plainBg": "#fff",
            "--joy-palette-background-surface": "#fff",
            [theme.getColorSchemeSelector("dark")]: {
              "--joy-palette-neutral-plainBg": "#000",
              "--joy-palette-background-surface": "#000",
            },
          })}
        >
          <Autocomplete
            open
            autoFocus
            multiple
            size="sm"
            placeholder="Filter labels"
            slots={{ listbox: ListboxComponent }}
            onClose={(event, reason) => {
              if (reason === "escape") {
                handleClose();
              }
            }}
            value={pendingValue}
            onChange={(event, newValue, reason) => {
              if (
                event.type === "keydown" &&
                (event.key === "Backspace" || event.key === "Delete") &&
                reason === "removeOption"
              ) {
                return;
              }
              setPendingValue(newValue);
            }}
            disableClearable
            disableCloseOnSelect
            forcePopupIcon={false}
            renderTags={() => null}
            noOptionsText="No labels"
            renderOption={(props, option, { selected }) => (
              <AutocompleteOption
                {...props}
                color="neutral"
                sx={(theme) => ({
                  alignItems: "flex-start",
                  border: "none",
                  borderBottom: "1px solid",
                  borderColor: "divider",
                  "--joy-palette-neutral-plainHoverBg": "rgba(0, 0, 0, 0.03)",
                  "--joy-palette-neutral-plainActiveBg": "rgba(0, 0, 0, 0.03)",
                  [theme.getColorSchemeSelector("dark")]: {
                    "--joy-palette-neutral-plainHoverBg": colors.grey[800],
                    "--joy-palette-neutral-plainActiveBg": colors.grey[800],
                  },
                  '&[aria-selected="true"]': {
                    fontWeight: "normal",
                  },
                  "&:first-of-type": {
                    borderTop: "1px solid",
                    borderColor: "divider",
                  },
                })}
              >
                <DoneIcon
                  sx={{ visibility: selected ? "visible" : "hidden" }}
                />
                <Avatar.LetterAvatar
                  name={option.name}
                  style={{
                    bgcolor: "blue",
                    width: 30,
                    height: 30,
                    fontSize: "12px",
                    color: theme.colors.white,
                    border: `2px solid ${theme.colors.white}`,
                  }}
                />

                <Box sx={{ flexGrow: 1 }}>
                  <Typography level="title-sm">{option.name}</Typography>
                  <Typography level="body-xs">{option.email}</Typography>
                </Box>
                {/* <CloseIcon
                  sx={{ visibility: selected ? "visible" : "hidden" }}
                /> */}
              </AutocompleteOption>
            )}
            options={[...labels].sort((a, b) => {
              // Display the selected labels first.
              let ai = value.indexOf(a);
              ai = ai === -1 ? value.length + labels.indexOf(a) : ai;
              let bi = value.indexOf(b);
              bi = bi === -1 ? value.length + labels.indexOf(b) : bi;
              return ai - bi;
            })}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.name}
            sx={{
              p: "4px 2px",
              borderTop: "1px solid",
              borderBottom: "1px solid",
              borderColor: "divider",
              "--Input-radius": "4px",
              m: "0.75rem 0.5rem",
            }}
          />
        </Sheet>
      </ClickAwayListener>
    </Popper>
  );
};

export default DropdownList;
